<template>
  <div class="search">
      <div class="icon__search">
          <img @click="focusInput" src="../assets/magnifying-glass.png" alt="search">
      </div>
      <div class="input__search">
        <input 
            v-on:input="searchProduct"
            v-model="text"
            type="text" 
            ref="text"
            placeholder="Поиск"
            name="search" 
            :readonly="is_read"
            @focus="focus_read"
        >
      </div>
      <div class="clear_input" @click="clearInput">
            <span class="mdi mdi-close" v-show="!getSearch"></span>
            <v-progress-circular v-show="getSearch" class="loader__color" indeterminate size="30"></v-progress-circular>
      </div>
      <div class="searchResultList" id="searchResultList_scroll">
          <div 
            class="list_search"
            v-for="searchResultId in searchResult"
            :key="searchResultId.id"
            @click="productId(searchResultId.id)"
          > 
              <p>
                  {{searchResultId.title}}
              </p>
              <p>
                  <b>{{searchResultId.price | numeral('0,0')}}</b> ₸
              </p>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'search',
  data () {
      return {
          text: '',
          searchResult: [],
          productsAll: [],
          getSearch: false,
          is_read: true
      }
  },
  components: {
  },
  
  methods: {
      getSearchProduct() {
        if (this.searchResult.length == 0) {
            let searchResultList = document.querySelector('.searchResultList')
            searchResultList.style.display = 'none'
        }
      },
      searchProduct() {
        this.getSearch = true
        let clear_input_b = document.querySelector('.clear_input')
        let searchResultList = document.querySelector('.searchResultList')

        if (this.text == '') {
            searchResultList.style.display = 'none'
            clear_input_b.style.display = 'none'
            this.getSearch = false
        } else if (this.text.length >= 4) {
            fetch(this.$apiURI + 'public/product/search?request=' + this.text + '&column=title')
            .then((res) => {
                res.json().then((data) => {
                    if (data.message == "Object with this data not found") {
                        this.searchResult = []
                        this.getSearch = false
                        searchResultList.style.display = 'none'
                    } else {
                        this.searchResult = data
                        this.getSearch = false
                    }
                });
            })
            searchResultList.style.display = 'block'
            clear_input_b.style.display = 'block'
        } else if (this.text.length <= 4) {
            this.getSearch = false
        }
      },
      focusInput() {
          this.$refs.text.focus();
      },
      productId(id) {
        let searchResultList = document.querySelector('.searchResultList')
        searchResultList.style.display = 'none'
        this.$router.push({ name: 'ProductPage', params: { id: id }})
      },
      viewClear() {
            if (this.text == '') {
                let clear_input_b = document.querySelector('.clear_input')
                clear_input_b.style.display = 'none'
                console.log(clear_input_b)
            }
      },
      clearInput() {
        this.text = ''
        if (this.text.length == 0) {
            let clear_input_b = document.querySelector('.clear_input')
            let searchResultList = document.querySelector('.searchResultList')
            searchResultList.style.display = 'none'
            clear_input_b.style.display = 'none'
        }
      },
      focus_read() {
          this.is_read = false
      }
  },
  mounted() {
      this.viewClear()
      this.getSearchProduct()
  }
}
</script>

<style scoped lang="less">
.search {
    width: 100%;
    height: 50px;
    border-radius: 5px;
    border: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    position: relative;
    background: #fff; 
    .clear_input {
        position: absolute;
        top: 0;
        right: 0;
        height: 50px;
        cursor: pointer;
        span {
            color: #606060;
            font-size: 43px;
        }
        .loader__color {
            color: #606060;
            margin-right: 5px;
            margin-top: 8px;
        }
    }
    #searchResultList_scroll::-webkit-scrollbar-track
    {
        background-color: transparent;
    }

    #searchResultList_scroll::-webkit-scrollbar
    {
        width: 10px;
    }

    #searchResultList_scroll::-webkit-scrollbar-thumb
    {
        border-radius: 2px;
        background-color: #680;
    }
    .searchResultList {
        width: 100%;
        position: absolute;
        top: 50px;
        left: 0;
        z-index: 100;
        height: 150px;
        overflow-y: scroll;
        
        .list_search {
            width: 100%;
            padding-top: 5px;
            background: #fff;
            padding-bottom: 5px;
            padding-left: 15px;
            border-bottom: 1px solid #680;
            cursor: pointer;
            &:hover {
                background: #f5f5f5;
            }
            p {
                color: #62644f;
                font-size: 15px;
            }
        }
    }
    .icon__search {
        width: 10%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &:hover {
            opacity: 0.7;
        }
        img {
            width: 24px;
            height: 24px;
        }
    }
    .input__search {
        width: 90%;
        height: 100%;
        input {
            width: 100%;
            height: 100%;
            background: white;
            padding-left: 5px;
            outline: none;
            font-size: 20px;
        }
    }
}
</style>